import React, { createContext, useContext, useState, ReactNode } from 'react';

interface UserDetailsContextType {
  currentUserName: string | null;
  setCurrentUserName: (name: string | null) => void;
}

const UserDetailsContext = createContext<UserDetailsContextType | undefined>(undefined);

export const useUserDetails = () => {
  const context = useContext(UserDetailsContext);
  if (context === undefined) {
    throw new Error('useUserDetails must be used within a UserDetailsProvider');
  }
  return context;
};

interface UserDetailsProviderProps {
  children: ReactNode;
}

export const UserDetailsProvider: React.FC<UserDetailsProviderProps> = ({ children }) => {
  const [currentUserName, setCurrentUserName] = useState<string | null>(null);

  return (
    <UserDetailsContext.Provider value={{ currentUserName, setCurrentUserName }}>
      {children}
    </UserDetailsContext.Provider>
  );
};
